
<div class="image">
  <asset-thumbnail *ngIf="bundle.asset" [asset]="bundle.asset" [root]="root"></asset-thumbnail>
</div>
<div class="bottom no-wrap" data-test-qa="name">{{name}}</div>
<media-item-labels data-test-qa="rating" *ngIf="bundle.asset" [bundle]="bundle" [location]="location" [showRating]="showRating" [showOffline]="true" [root]="root"></media-item-labels>
<div class="duration" *ngIf="bundle.asset?.format.duration">{{bundle.asset.format.duration|time:bundle.asset.format.fps:'short'}}</div>
<checkbox class="media-huge-checkbox" *ngIf="selectable" [checked]="mediaBrowserSelection.isSelected(bundle)" (click)="onCheckbox($event)"></checkbox>